import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Navngiv dette trykjob',
      placeholder: 'A5-flyer – særtilbud',
    },
    format: {
      label: 'Produkttype',
      placeholder: 'Vælg produkttype',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Klistermærke (60x60 mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Dørklistermærke (30x30 cm)',
      },
    },
    file: {
      label: 'Fil',
    },
  },
  buttons: {
    upload: 'Klik eller træk for at uploade fil',
    save: 'Gem',
  },
  toasts: {
    changes_got_saved: 'Ændringerne er gemt!',
  },
};
